// Területek a root megadott teljes területéből: a root területét a jelenleg felvett
// (legalsó szintű) locationök között a térképi méretük arányában osztja szét.
// A technikai locationök ugyanezzel a m²/képpont aránnyal kapják a saját területüket,
// a több szintű locationök a gyermekeik összegét.

const pixelArea = (item) => Math.max(0, Number(item.width) || 0) * Math.max(0, Number(item.height) || 0);

export function computeLocationAreas(rects = [], technicalLocations = []) {
  const locationAreaById = new Map();
  const technicalAreaById = new Map();
  const locations = rects.filter((rect) => rect.type !== "technical" && !rect.is_system_generated);
  const childrenById = new Map();
  locations.forEach((rect) => {
    if (rect.parent_location_id == null) return;
    const key = String(rect.parent_location_id);
    childrenById.set(key, [...(childrenById.get(key) || []), rect]);
  });

  const leavesUnder = (rect) => {
    const children = childrenById.get(String(rect.id)) || [];
    return children.length ? children.flatMap(leavesUnder) : [rect];
  };

  locations.filter((rect) => rect.is_root && Number(rect.area_m2) > 0).forEach((root) => {
    const descendants = (childrenById.get(String(root.id)) || []).flatMap(function walk(rect) {
      return [rect, ...(childrenById.get(String(rect.id)) || []).flatMap(walk)];
    });
    const leaves = leavesUnder(root).filter((rect) => rect !== root);
    const leafPixels = leaves.reduce((sum, rect) => sum + pixelArea(rect), 0);
    locationAreaById.set(String(root.id), Number(root.area_m2));
    if (!leafPixels) return;
    const squareMetresPerPixel = Number(root.area_m2) / leafPixels;
    descendants.forEach((rect) => {
      const pixels = leavesUnder(rect).reduce((sum, leaf) => sum + pixelArea(leaf), 0);
      locationAreaById.set(String(rect.id), pixels * squareMetresPerPixel);
    });
    const descendantIds = new Set(descendants.map((rect) => String(rect.id)));
    technicalLocations
      .filter((area) => descendantIds.has(String(area.parent_location_id)))
      .forEach((area) => technicalAreaById.set(String(area.id), pixelArea(area) * squareMetresPerPixel));
  });

  return { locationAreaById, technicalAreaById };
}

// Egy location-halmaz összterülete. Ha egy location és az őse is benne van,
// csak az őse számít, hogy ne legyen kétszer beleszámolva.
export function totalArea(locationIds = [], rects = [], locationAreaById = new Map()) {
  const ids = new Set(locationIds.map(String));
  const parentById = new Map(rects.map((rect) => [String(rect.id), rect.parent_location_id == null ? null : String(rect.parent_location_id)]));
  const hasAncestorInSet = (id) => {
    let parent = parentById.get(id);
    while (parent) {
      if (ids.has(parent)) return true;
      parent = parentById.get(parent);
    }
    return false;
  };
  let total = 0;
  let known = 0;
  ids.forEach((id) => {
    if (hasAncestorInSet(id) || !locationAreaById.has(id)) return;
    total += locationAreaById.get(id);
    known += 1;
  });
  return known ? total : null;
}

export function formatArea(value) {
  if (value == null || !Number.isFinite(value)) return null;
  return `${value >= 10 ? Math.round(value) : value.toFixed(1)} m²`;
}
